module.exports = __webpack_public_path__ + "static/media/jlr.976e6349.svg";